import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    zoneName: yup
        .string()
        .required('Required'),
    zoneCode: yup
        .string()
        .required('Required'),
    rackId: yup.array()
        .of(yup.string())
        .min(1, "Min 1 selection")
        .required('Required'),
    workerId: yup.array()
        .of(yup.string())
        .min(1, "Min 1 selection")
        .required('Required'),
    sequence: yup
        .number()
        .typeError("Only number")
        .required('Required')
        .test(
            "is-positive",
            "Please enter a positive number",
            (value) => value >= 0 && 1 / value !== -Infinity),
})

export const initialValues = {
    zoneName: "",
    zoneCode: "",
    sequence: "",
    status: true,
    defaultStatus: false,
    rackId: [],
    workerId: []
}